module.exports = __webpack_public_path__ + "img/intro3.eb988fd7.png";